import React from "react";

const Heading = ({ text="", color="black", link, ...res }) => {
    let colorClass = ""

    if (color === "black") {
        colorClass = "text-black";
    } else if (color === "white") {
        colorClass = "text-white";
    } else if (color === "red") {
        colorClass = "text-rs-rojo";
    } else if (color === "blue") {
        colorClass = "text-rs-azul";
    };

    return(
        <h1 className={`font-bold text-xl md:text-3xl ${colorClass} ${link  ? "underline cursor-pointer" : null } `} {...res}>
            {text}
        </h1>
    )
};

export default Heading;